import * as React from "react";
import { forwardRef } from "react";
const SvgProgressLineChart = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.21484 11.2304L6.69623 6.20478L10.4941 9.79452L15.2414 2.43555", stroke: "white", strokeMiterlimit: 10, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1 1V15H15.875", stroke: "white", strokeMiterlimit: 10, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgProgressLineChart);
export { ForwardRef as ReactComponent };
